import moment from 'moment';

import { Capitalize, pm } from 'lib/helpers/utility';

import Actions from '../components/Actions';
import ColorCircle from '../components/ColorCircle';

export const generateColumnDefs = (permissions) => [
  { field: 'id', headerName: 'ID' },
  { field: 'name', headerName: 'Name' },
  { field: 'color', headerName: 'Color', cellRenderer: ColorCircle },
  { field: 'status', headerName: 'Status', valueFormatter: ({ value }) => Capitalize(value) },
  { field: 'state', headerName: 'State', valueFormatter: ({ value }) => Capitalize(value) },
  {
    field: 'last_active',
    headerName: 'Last Active',
    valueFormatter: ({ value }) => moment(value).format('MM/DD/YYYY HH:mm.ss')
  },
  ...(pm(permissions, ['kiosk.update', 'kiosk.delete'], 'or')
    ? [
        {
          field: 'actions',
          headerName: 'Actions',
          cellRenderer: Actions,
          maxWidth: 88,
          minWidth: 36,
          resizable: false,
          sortable: false,
          pinned: 'right'
        }
      ]
    : [])
];
